import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { NavLink } from "react-bootstrap";
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';
import ConfirmDeleteModal from "./ConfirmationModelDelete";

const CasteList = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [searchQueryCaste, setSearchQueryCaste] = useState("");
  const [searchQuerySubCaste, setSearchQuerySubCaste] = useState("");
  const [searchQueryGotra, setSearchQueryGotra] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  // Function to fetch data from API
  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/caste`, {
        params: {
          page: currentPage,
          limit: 10, // Assuming you want 10 items per page based on your backend API
          caste: searchQueryCaste,
          subcaste: searchQuerySubCaste,
          gotra: searchQueryGotra
        },
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      console.log(response.data);
      setUsers(response.data.entries);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  // Function to handle pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Function to handle search by caste
  const handleSearchCaste = (e) => {
    setSearchQueryCaste(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Function to handle search by subcaste
  const handleSearchSubCaste = (e) => {
    setSearchQuerySubCaste(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Function to handle search by gotra
  const handleSearchGotra = (e) => {
    setSearchQueryGotra(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // useEffect hook to fetch data initially and on dependency change
  useEffect(() => {
    getData();
  }, [currentPage, searchQueryCaste, searchQuerySubCaste, searchQueryGotra]);

  // Function to navigate to edit page
  const handleEdit = (id) => {
    history.push(`/editcaste/${id}`);
  };

  // Function to handle deletion
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/caste/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        getData(); // Refresh data after deletion
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false); // Close modal after deletion
  };

  // Function to handle delete modal opening
  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  // Function to handle CSV download
  const handleDownload = () => {
    const fields = ["id", "caste", "subcaste", "gotra","createdAt"];
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(users);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'caste.csv');
  };

  // Function to format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Caste List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-6">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Caste"
              value={searchQueryCaste}
              onChange={handleSearchCaste}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Search By Sub Caste"
              value={searchQuerySubCaste}
              onChange={handleSearchSubCaste}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Search By Gotra"
              value={searchQueryGotra}
              onChange={handleSearchGotra}
            />
          </div>
          <div>
            <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{textAlign:"center"}}>
              <tr>
                <th>S.No</th>
                <th>Caste</th>
                <th>Sub Caste</th>
                <th>Gotra</th>
              
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody  style={{textAlign:"center"}}>
              {users.map((user, index) => (
                <tr key={user._id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{user.caste}</td>
                  <td>{user.subcaste}</td>
                  <td>{user.gotra}</td>
                  <td>{formatDate(user.createdAt)}</td>
                  <td>
                    <i className="icon-pencil" onClick={() => handleEdit(user._id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user._id)}></i>
                  </td>
                
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

export default CasteList;
